import {http_endPointPath_oa, http_functions_fp} from "@/scripts/Server/S_HttpRequests";

import {FB_ServerAns} from '../../../functions/src/shareCode/Share_S_Classes'

// server_endPoint_subscriptionCharge_fp
export const server_endPoint_subscriptionCharge_fp = async (uds_subscriptionInfo_c) =>{

    return new FB_ServerAns(await http_functions_fp({
        path_as: http_endPointPath_oa.FUNCTIONS_endPoint_subscriptionCharge,
        data_c: uds_subscriptionInfo_c,
    }))

}
